import React, { Fragment } from "react";

import TabView from "../../react_utils/TabView";
import ClientGroup from "./clients/ClientGroup";
import { stateOptions } from "../../shared/hooks/client/useClients";

export default function Clients() {
  return (
    <Fragment>
      <TabView
        components={[
          {
            title: "Alle",
            getChild: () => <ClientGroup state={null} />,
          },
          ...stateOptions.map((option) => ({
            title: option.label,
            getChild: () => <ClientGroup state={option.value} />,
          })),
        ]}
      />
    </Fragment>
  );
}

Clients.propTypes = {};
